import { render, staticRenderFns } from "./DonutChart33.vue?vue&type=template&id=1f01ddee&scoped=true"
import script from "./DonutChart33.vue?vue&type=script&lang=js"
export * from "./DonutChart33.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f01ddee",
  null
  
)

export default component.exports